import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import boot from '@/boot'
import {Lazyload} from 'vant'
import 'vant/lib/index.css';
import { VueClipboard } from '@soerenmartius/vue3-clipboard'
import { i18n } from '@/i18n/index';
import store from '@/store/wallet'
import "animate.css/animate.min.css"
const app:any = createApp(App)
boot(app)
app.config.globalProperties.$t = i18n.global.t;
app.use(store).use(i18n).use(Lazyload,{lazyComponent:true}).use(router).use(VueClipboard).mount('#app')
